export enum ExtendedNavId {
  Messaging = 'messaging',
  Reports = 'reports',
}
